var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardActionCloseIcons({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1870_48819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.291 7.29297L11.998 10.586L8.70502 7.29297L7.29102 8.70697L10.584 12L7.29102 15.293L8.70502 16.707L11.998 13.414L15.291 16.707L16.705 15.293L13.412 12L16.705 8.70697L15.291 7.29297Z",
    fill: "#014D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9961 0C9.62272 0 7.30265 0.703788 5.32926 2.02236C3.35587 3.34094 1.8178 5.21509 0.909545 7.4078C0.00129318 9.60051 -0.236347 12.0133 0.226676 14.3411C0.689698 16.6689 1.83259 18.8071 3.51082 20.4853C5.18905 22.1635 7.32724 23.3064 9.65501 23.7694C11.9828 24.2324 14.3956 23.9948 16.5883 23.0866C18.781 22.1783 20.6552 20.6402 21.9737 18.6668C23.2923 16.6935 23.9961 14.3734 23.9961 12C23.9927 8.81846 22.7273 5.76821 20.4776 3.51852C18.2279 1.26883 15.1776 0.00344108 11.9961 0ZM11.9961 22C10.0183 22 8.08489 21.4135 6.4404 20.3147C4.79591 19.2159 3.51418 17.6541 2.7573 15.8268C2.00043 13.9996 1.80239 11.9889 2.18825 10.0491C2.5741 8.10929 3.52651 6.32746 4.92503 4.92893C6.32356 3.53041 8.10539 2.578 10.0452 2.19215C11.985 1.8063 13.9957 2.00433 15.8229 2.7612C17.6502 3.51808 19.212 4.79981 20.3108 6.4443C21.4096 8.08879 21.9961 10.0222 21.9961 12C21.9932 14.6513 20.9387 17.1931 19.0639 19.0679C17.1892 20.9426 14.6474 21.9971 11.9961 22Z",
    fill: "#014D6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1870_48819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardActionCloseIcons);
export default __webpack_public_path__ + "static/media/card-action-close-icons.1c0ce0be286e4b780a473e98f10cfa90.svg";
export { ForwardRef as ReactComponent };